/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HpRespPromoModulePrimary_homepage$ref: FragmentReference;
export type HpRespPromoModulePrimary_homepage = {|
  +promoPrimaryModule: ?{|
    +title?: ?string,
    +items?: ?$ReadOnlyArray<?{|
      +cmsId: ?number,
      +link: ?string,
      +imageUrl?: ?string,
      +mobileImageUrl?: ?string,
    |}>,
  |},
  +$refType: HpRespPromoModulePrimary_homepage$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "HpRespPromoModulePrimary_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "promoPrimaryModule",
      "name": "module",
      "storageKey": "module(type:\"promoPrimary\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "promoPrimary",
          "type": "String!"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "PromoModule",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "PromoItem",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "link",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "Condition",
                  "passingValue": true,
                  "condition": "isMobile",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "mobileImageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "Condition",
                  "passingValue": false,
                  "condition": "isMobile",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "imageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '524a5417f997647fe4ceddb13b094dc5';
module.exports = node;
